import { render, staticRenderFns } from "./ExpandTable.vue?vue&type=template&id=830c17d4&scoped=true"
import script from "./ExpandTable.vue?vue&type=script&lang=js"
export * from "./ExpandTable.vue?vue&type=script&lang=js"
import style0 from "./ExpandTable.vue?vue&type=style&index=0&id=830c17d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830c17d4",
  null
  
)

export default component.exports